

























import A01PanelHeadingTitle from "@/general/components/pages/parts/Top/A01PanelHeadingTitle.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconPresent from "@/common/components/icons/IconPresent.vue";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import { Prop, Component, Vue } from "vue-property-decorator";
import CONST_DATA from "@/general/mixins/const/constData";
import { RandomUserAvatar } from "@/general/store/models";

@Component({
  components: {
    A01PanelHeadingTitle,
    ButtonMain,
    IconPresent
  }
})
export default class LinkToThanksPointPagePanel extends Vue {
  @Prop({
    type: Array,
    required: false
  })
  members!: RandomUserAvatar[];

  get url() {
    return (
      process.env.VUE_APP_IC_DOMAIN +
      CONST_DATA.SITE_MAP.THANKS_POINT_USER_SELECTION
    );
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }
}
